jQuery(document).ready(function($){

  $('#news-events .col-1-2').each(function(){
    $('.row', this).last().addClass('last');
  });


  $("#trigger-search").click(function(e){
      e.preventDefault();
      $(".search_header").slideToggle();
      $(this).toggleClass("close");
  });


  //hero slider for homepage
  var $flexslider = $('#hero .flexslider');
   $flexslider.flexslider({
     animation: "fade",
     manualControls: ".flex-control-nav li",
     useCSS: false,
     start: function(slider){
       //slide index
       var showingSlideIndex = slider.currentSlide;
       transitionHeroCaption(showingSlideIndex);
     },
     after: function(slider){
       //slide index
       var showingSlideIndex = slider.currentSlide;
       transitionHeroCaption(showingSlideIndex);
     }
    });

   var $slides = jQuery("#hero .flexslider .slides li");
   function transitionHeroCaption(showingSlideIndex){
     //hide any showing captions
     jQuery('.caption').each(function(){
       jQuery(this).attr("style", "");
     });
     //slide in active slides caption
     jQuery($slides[showingSlideIndex]).find(".caption").animate({
       opacity: "1",
       filter: 'alpha(opacity=100)'
     }, 750, 'easeOutCubic', function() {});
   }

  //mobile menu function
  var menuOpen = false,
   $wrapper = $('.site-wrapper'),
   $nav = $('.main-navigation'),
   $menuButton = $('.menu-btn'),
   closeNav = function(){
     $wrapper.removeClass('menu-open');
     $menuButton.removeClass('active');
     closeTertiaryFn();

     //remove any inline styles from subnavigation
     $('.main-navigation ul').removeAttr('style');

     menuOpen = false;
   },
   menuBtnFn = function(){

     $menuButton.bind( 'touchstart, click', function(ev){

       ev.stopPropagation();
       ev.preventDefault();

       if ( menuOpen ) {
         closeNav();
       } else {
         $wrapper.addClass('menu-open');
         $(this).addClass('active');

         $('.main-navigation ul li.menu-item-has-children a').each(function(){

           if( $(this).parent().hasClass('current-menu-ancestor') || $(this).parent().hasClass('current-menu-item') ) {

             $(this).parent().addClass('expanded');
             $(this).next().addClass('expanded');
             $(this).parent().stop().children('ul').slideDown();
           }

         });

         menuOpen = true;
       }
     });
   };

   menuBtnFn();
   //secondlevelNav();

   //resize functions
   $(window).resize(function(){
     $('.feature-box .content').removeAttr('style');
     $('.feature-box .content').equalizeHeight();

     if( !$menuButton.is(':visible') ) {
       closeNav();
     } else {
       /*$('.main-navigation ul li.menu-item-has-children a').each(function(){

         $(this).bind('touchstart, click', function(ev){

           if ( menuOpen && !$(this).next().is(':visible') && $(this).next().length > 0) {

             ev.stopPropagation();
             ev.preventDefault();

             //close whats already open
             closeTertiaryFn();

             //$('ul.expanded').stop().slideUp();
             //$('ul.expanded').removeClass('expanded');
            // $('li.expanded').removeClass('expanded');

             //expand current click
             $(this).parent().addClass('expanded');
             $(this).next().addClass('expanded');
             $(this).parent().stop().children('ul').slideDown();
           }

         });
       });*/
       //$('.utility').appendTo('.main-navigation');

       //2nd level
        $('.main-navigation > ul > li > a').bind('touchstart, click', function(ev){
                if ( menuOpen && !$(this).next().is(':visible') && $(this).next().length > 0) {

                    //console.log( 'clicked top level to show second');

                      ev.stopPropagation();
                      ev.preventDefault();

                      $('.main-navigation > ul > li').removeClass('expanded');
                      $('.main-navigation > ul > li > ul').removeClass('expanded');

                      //expand current click
                      $(this).parent().addClass('expanded');
                      $(this).next().addClass('expanded');
                      $(this).parent().stop().children('ul').slideDown();

                      /*$('nav.topNav > ul li a').removeClass('toggle');
                      $(this).addClass('toggle');
                      $('nav.topNav ul > li > ul').slideUp('fast');
                      $(this).next().slideDown('fast');*/
                }
          });
        //3rd level
        $('.main-navigation > ul > li ul > li > a').bind('touchstart, click', function(ev){
                if ( menuOpen && !$(this).next().is(':visible') && $(this).next().length > 0) {

                    //console.log( 'clicked second level to show third');

                      ev.stopPropagation();
                      ev.preventDefault();

                      $('.main-navigation > ul > li li').removeClass('expanded');
                      $('.main-navigation > ul > li > ul ul').removeClass('expanded');

                      //expand current click
                      $(this).parent().addClass('expanded');
                      $(this).next().addClass('expanded');
                      $(this).parent().stop().children('ul').slideDown();
                }
          });


     }
   });

   closeTertiaryFn = function(){
     //close expanded tertiary
     $('ul.expanded').stop().slideUp();
     $('ul.expanded').removeClass('expanded');
     $('li.expanded').removeClass('expanded');
   }

   //Add class to archive sidebar to highlight current year
	if(archiveVars.isYear){
		jQuery('#archive_sidebar_items li a')
		.filter(function(index) { return jQuery(this).text() === archiveVars.archiveYear; })
		.parent('li')
		.addClass('current-archive');
	}

	//Add class to author sidebar to highlight current year
	if(authorVars.isAuthor){
		jQuery('#author_sidebar_items li a')
		.filter(function(index) { return jQuery(this).attr('href') === authorVars.authorArchiveUrl; })
		.parent('li')
		.addClass('current-author');
	}

  // Accordions
  $('dl.accordion').accordion();

   //trigger resize on page load for layout adjustments
   $(window).trigger('resize');

});



//equalizeHeight function
(function($){
	'use strict';
	$.fn.equalizeHeight = function(){
		var tallestHeight = 0,
		$box = this;

		$box.each(function(i, e){
			var elHeight = $(e).outerHeight();

			if(elHeight > tallestHeight) {
				tallestHeight = elHeight;
			}
		});

		$box.css('height', tallestHeight);

		return this;
	}
}(jQuery));
